import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Descriptions as AntdDescriptions, Space, Typography } from 'antd';
import styled from 'styled-components';

import { type FormattedClaimDetails } from 'utils/formatClaimDetails';
import { StyledTitle } from 'components/StyledTitle';
import { DocumentLink } from 'components/documentLink/DocumentLink';

const { Text } = Typography;

const TitleSection = styled(Space)`
  margin-bottom: 1rem;
`;

const Descriptions = styled(AntdDescriptions)`
  background-color: var(--white);
`;

export type PartialClaimInformationProps = Pick<
  FormattedClaimDetails,
  'otherClaimAmount' | 'otherInsurerName' | 'anotherPolicyNumber' | 'anotherMemberId' | 'prevClaimFiles'
>;

const PartialClaimInformation: FC<PartialClaimInformationProps> = ({
  otherInsurerName,
  otherClaimAmount,
  anotherPolicyNumber,
  anotherMemberId,
  prevClaimFiles,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <TitleSection>
        <StyledTitle level={5}>{t('claimDetails.partialClaimInformation')}</StyledTitle>
      </TitleSection>
      <Descriptions bordered column={1}>
        {otherInsurerName && (
          <Descriptions.Item label={t('claimDetails.insurer')}>
            <Text>{otherInsurerName}</Text>
          </Descriptions.Item>
        )}
        {otherClaimAmount && (
          <Descriptions.Item label={t('claimDetails.claimAmount')}>
            <Text>
              {otherClaimAmount.currency} {otherClaimAmount.amount}
            </Text>
          </Descriptions.Item>
        )}
        {anotherPolicyNumber && (
          <Descriptions.Item label={t('claimDetails.anotherGeneraliPolicyNumber')}>
            <Text>{anotherPolicyNumber}</Text>
          </Descriptions.Item>
        )}
        {anotherMemberId && (
          <Descriptions.Item label={t('claimDetails.anotherGeneraliMemberId')}>
            <Text>{anotherMemberId}</Text>
          </Descriptions.Item>
        )}
        {(prevClaimFiles || []).length > 0 && (
          <Descriptions.Item label={t('claimDetails.settlementAdvice')}>
            {prevClaimFiles?.map((filePath) => (
              <div key={filePath}>
                <DocumentLink filePath={filePath} key={filePath} />
              </div>
            ))}
          </Descriptions.Item>
        )}
      </Descriptions>
    </div>
  );
};
export default PartialClaimInformation;
